import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback, useEffect } from 'react';
import '../../../../../constants/modelCompareData/assets/plus.svg.mjs';
import { useModelCompareTranslation } from '../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { imageSrc } from '../../../../../utils/asset.mjs';
import { Product as Product$1, ProductCardOnClickArea, Image, DescriptionButtonContainer, Name, Description, Button, ButtonIcon, ButtonCopy, CopyWhiteSpace } from '../../ProductList.styles.mjs';
import plusIcon__default from "../../../../../assets/plus2.svg";
"use strict";
const Product = ({
  id,
  groupId,
  image,
  name,
  description,
  selectedProducts,
  setSelectedProducts,
  groupIsActive,
  groupIndex,
  groupLength,
  playAnimation,
  canPlayAniimation,
  selectedProductsLimit,
  setExternalState,
  showProductGroups,
  isStaticProduct,
  isOverviewPage,
  onClick
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  const [startingClickPosition, setStartingClickPosition] = useState(0);
  const [hasBeenClicked, setHasBeenClicked] = useState(false);
  const isSelected = useMemo(() => selectedProducts.some(product => product.productId === id), [selectedProducts, id]);
  const isOnlySelectedProduct = useMemo(() => isSelected && selectedProducts.length === 1, [isSelected, selectedProducts]);
  const isDisabled = useMemo(() => !isSelected && selectedProducts.length === selectedProductsLimit || isOnlySelectedProduct, [isSelected, selectedProducts, selectedProductsLimit, isOnlySelectedProduct]);
  const buttonClickHandler = useCallback(() => {
    const newProductList = selectedProducts.filter(product => product.productId !== id);
    if (setExternalState) {
      setExternalState(prev => isSelected ? newProductList : [...prev, {
        productId: id,
        groupId
      }]);
    }
    setSelectedProducts(prev => isSelected ? newProductList : [...prev, {
      productId: id,
      groupId
    }]);
  }, [selectedProducts, id, groupId, isSelected, setExternalState, setSelectedProducts]);
  const onPointerUpHandler = event => {
    if (event.clientX === startingClickPosition) setHasBeenClicked(true);
  };
  useEffect(() => {
    if (hasBeenClicked) {
      onClick();
      setHasBeenClicked(false);
    }
  }, [hasBeenClicked, onClick]);
  return /* @__PURE__ */jsxs(Product$1, {
    $isActive: groupIsActive,
    $groupIndex: groupIndex,
    $groupLength: groupLength,
    $playAnimation: playAnimation,
    $canPlayAniimation: canPlayAniimation,
    $productGroupsSelectorExists: showProductGroups,
    children: [/* @__PURE__ */jsx(ProductCardOnClickArea, {
      onPointerDown: event => setStartingClickPosition(event.clientX),
      onPointerUp: event => onPointerUpHandler(event)
    }), image.src && /* @__PURE__ */jsx(Image, {
      loading: "lazy",
      decoding: "async",
      src: imageSrc(image.src),
      alt: name,
      width: image.width,
      height: image.height
    }), /* @__PURE__ */jsxs(DescriptionButtonContainer, {
      children: [/* @__PURE__ */jsx(Name, {
        children: name
      }), description && /* @__PURE__ */jsx(Description, {
        children: formatMessage(description)
      }), /* @__PURE__ */jsxs(Button, {
        $isStaticProduct: !isOverviewPage && isStaticProduct,
        $isSelected: isSelected,
        $disabled: isDisabled,
        type: "button",
        disabled: isDisabled,
        onClick: buttonClickHandler,
        children: [/* @__PURE__ */jsx(ButtonIcon, {
          $isSelected: isSelected,
          src: plusIcon__default,
          width: 20,
          height: 20
        }), /* @__PURE__ */jsxs(ButtonCopy, {
          children: [formatMessage(`commons.productList.button.${isSelected ? "active" : "inactive"}`), isSelected && /* @__PURE__ */jsx(CopyWhiteSpace, {})]
        })]
      })]
    })]
  });
};
export { Product };
//# sourceMappingURL=Product.mjs.map
